<template><tile-question-layout v-if="panel_required" :options_loaded="options_loaded" :passed_filter="passed_filter" :panel_required="panel_required" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :fabricator="fabricator">

</tile-question-layout></template>

<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Select A Hardware Suite';
                }
            },
            slab: {
                required: true
            },
            securedByDesign: {
                required: true
            },
            openingDirection: {
                required: true
            },
            component_id: {
                default(){
                    return 'hardware_suite';
                }
            },
            doorRange: {
                required: true
            },
            suites: {
                default(){
                    return '';
                }
            },
            collection: {
                required: false,
                default(){
                    return '';
                }
            },
            profile: {
                required: true
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.slab, this.securedByDesign, this.openingDirection, this.doorRange, this.profile, this.collection);
            },
            thumbURL(){
                return '/thumb/suite/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-suite-selector?suites=' + this.suites + '&slab=' + this.slab + '&secured_by_design=' + this.securedByDesign + '&opening_direction=' + this.openingDirection + '&door_range=' + this.doorRange + '&profile=' + this.profile + '&collection=' + this.collection;
            },
            cache_key(){
                return '_' + this.slab + '_' + this.securedByDesign + '_' + this.openingDirection + '_' + this.doorRange + '_' + this.profile + '_' + this.collection;
            },
            panel_required(){
                return true;
            }
        },
        watch: {
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'securedByDesign': function (val, oldVal) {
                this.update_options();
            },
            'openingDirection': function (val, oldVal) {
                this.update_options();
            },
            'profile': function (val, oldVal) {
                this.update_options();
            },
            'collection': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
